<template>
    <div
        v-if="profile && dataLoaded"
        class="d-flex h-100"
    >
        <div
            style="width: 250px"
            class="pa-2"
        >
            <div>
                <div class="royal-blue w-100 d-flex align-center rounded-lg mb-4" style="position:relative;">
                    <div
                        style="position: absolute; left: 12px; top: 6px; padding: 2px; border-radius: 100%"
                        class="white"
                    >
                        <AccountAvatar
                            :color="profile.person_settings.avatar ? 'white' : 'neutral_n40'"
                            text-color="neutral_n300"
                            text-class="font-weight-medium"
                            :initials="profile.person_settings.initials ? profile.person_settings.initials : 'err'"
                            :image-path="profile.person_settings.avatar ? profile.person_settings.avatar : ''"
                        />
                    </div>
                    <v-spacer/>
                    <router-link
                        :to="{ name: 'report', query: { view: 'summary', person_id_list: personId }}"
                        class="text-decoration-none"
                    >
                        <icon-button color="inverted" icon="BarChart4"/>
                    </router-link>
                </div>
                <div class="px-3">
                    <div class="title">
                        {{ profile.person_settings.first_name ? profile.person_settings.first_name : '' }} {{ profile.person_settings.surname ? profile.person_settings.surname : '' }}
                    </div>
                </div>
            </div>
            <div class="mt-5">
                <SideNavigation :tabs="tabs"/>
            </div>
        </div>
        <div :class="['w-100 px-10 py-3', ['settings', 'vacations', 'agreements'].includes(tabs[selectedTab].value) ? 'white elevation-4' : '']">
            <router-view :profile="profile" :person-id="personId" :workforce-management-settings="workforceManagementSettings"/>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {$t} from "@/i18n";
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import {Router} from "@/composables/Router";
import SideNavigation from "@/components/Navigation/SideNavigation";
import AccountModule from "@/store/modules/account";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import AccountAvatar from "@/components/AccountAvatar";
import ApiProfile from "@/api/profile/profile";
import {APP_STORE_APP_IDS, APP_STORE_APP_TYPES} from "../../helpers/constants";

export default {
    name: "ProfileView",
    components: {
        AccountAvatar,
        SideNavigation
    },
    setup(props, ctx) {
        const {
            current_account,
            isFeatureEnabled
        } = AccountModule();
        const router = Router();
        const profile = ref(null);

        const current_route = computed(() => ctx.root._route);

        const flextimeCompanies = computed(() => profile.value ? profile.value.companies.filter(x => x.flextime_active) : [])
        const workforceManagementSettings = ref([])
        const showNotes = ref(false)
        const showInfo = ref(false)
        const dataLoaded = ref(false)

        const tabs = computed(() => {
            let tabs = [
                {text: $t("Settings"), value: "settings", route: {name: "profile_settings"}},
                showInfo.value ? {text: $t("Info"), value: "info", route: {name: "profile_info"}} : null,
                showNotes.value ? {text: $t("Notes"), value: "notes", route: {name: "profile_notes"}} : null,
                flextimeCompanies.value.length ? {text: $t("Agreements"), value: "agreements", route: {name: "profile_agreements"}} : null,
            ]

            if (profile.value && profile.value.companies && profile.value.companies.find(x => isFeatureEnabled(x.id, APP_STORE_APP_TYPES.VACATIONS, false))) {
                tabs.push({text: $t("Vacations"), value: "vacations", route: {name: "profile_vacations"}})
            }

            return tabs.filter(x => x)
        })


        const selectedTab = computed(() => Math.max(tabs.value.findIndex(tab => tab.route.name === current_route.value.name), 0));

        const onNavTabClick = (tab) => {
            return router.push({name: tab.route.name});
        };

        const updateSelected = function (value) {
            ctx.emit("input", value);
        };

        const personId = computed(() => {
            const personId = Number(ctx.root._route.params.personId)
            return personId ? personId : current_account.value.id
        })

        onMounted(async () => {
            try {
                // todo :: refactor to feature.js api
                const {data} = await axios.get(`/features/${APP_STORE_APP_IDS.WORKFORCE_MANAGEMENT}/all`)
                workforceManagementSettings.value = data
                showInfo.value = workforceManagementSettings.value.findIndex((x) => x.data.allow_member_fields && isFeatureEnabled(x.account_id, APP_STORE_APP_TYPES.MEMBER_FIELDS, false)) !== -1
                showNotes.value = workforceManagementSettings.value.findIndex((x) => x.data.allow_member_notes && isFeatureEnabled(x.account_id, APP_STORE_APP_TYPES.MEMBER_FIELDS, false)) !== -1
                dataLoaded.value = true
            } catch (e) {
                errorDialog.showError(e)
            }
        })

        watch(() => personId.value, async () => {
            profile.value = null
            try {
                profile.value = await ApiProfile.getProfile(personId.value)
            } catch (e) {
                errorDialog.showError(e)
            }

        }, {immediate: true})

        return {
            updateSelected,
            tabs,
            selectedTab,
            onNavTabClick,
            SideNavigation,
            personId,
            profile,
            workforceManagementSettings,
            dataLoaded
        };
    }
};
</script>
